import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  LicensePlate,
} from "@rumble-it/common-components/components";
import { Descriptions } from "antd";
import type { Dossier } from "@/types/dossier.interface";

export const DossierSummaryCard = ({ dossier }: { dossier: Dossier }) => {
  const vehicle = dossier.vehicle;
  const driver = dossier.driver;
  const kilometers = dossier.kilometers ?? vehicle?.kilometers ?? null;
  const brandAndModel = [vehicle?.brand, vehicle?.model]
    .filter(Boolean)
    .join(" — ");

  return (
    <Card>
      <CardHeader>
        <CardTitle>Dossiergegevens</CardTitle>
      </CardHeader>

      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <h3 className="font-bold mb-3">Voertuig</h3>

            <div className="mb-3">
              <LicensePlate country="NL">
                {vehicle?.licensePlate?.identifier || "Onbekend"}
              </LicensePlate>
            </div>

            <Descriptions
              column={1}
              size="small"
              items={[
                {
                  label: "Merk / model",
                  children: brandAndModel || "Onbekend",
                },
                {
                  label: "Kilometerstand",
                  children:
                    kilometers !== null && kilometers !== undefined
                      ? `${kilometers} km`
                      : "Onbekend",
                },
              ]}
            />
          </div>

          <div>
            <h3 className="font-bold mb-3">Bestuurder</h3>

            <Descriptions
              column={1}
              size="small"
              items={[
                {
                  label: "Naam",
                  children: driver?.person?.fullName || "Onbekend",
                },
                {
                  label: "Telefoon",
                  children: driver?.person?.telephone || "Onbekend",
                },
                {
                  label: "E-mail",
                  children: driver?.person?.email || "Onbekend",
                },
                {
                  label: "Adres",
                  children: driver?.address
                    ? `${driver.address.street} ${driver.address.streetNumber}${
                        driver.address.streetNumberAddition || ""
                      }, ${driver.address.postalCode} ${driver.address.city}`
                    : "Onbekend",
                },
              ]}
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
